<template>
	<div class="card">
		<div class="card-body">
			<div class="row align-items-center">
				<div class="col-md-2 col-6">
					<base-input label="วันที่">
						<flat-picker class="form-control datepicker" v-model="startDate" />
					</base-input>
				</div>
				<div class="col-md-2 col-6">
					<base-input label="ถึง">
						<flat-picker class="form-control datepicker" v-model="endDate" />
					</base-input>
				</div>
			</div>

			<div class="row mt-4">
				<div class="col-md-8">
					<affiliate-report-panel :data="reports" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { Select, Option } from 'element-ui'
import flatPicker from 'vue-flatpickr-component'
import AffiliateReportPanel from '../backend-components/Summary/AffiliateReportPanel'

import moment from 'moment'
import api from '../services'

export default {
	components: {
		[Select.name]: Select,
		[Option.name]: Option,
		flatPicker,
		AffiliateReportPanel,
	},
	data() {
		return {
			startDate: moment().format('YYYY-MM-DD'),
			endDate: moment().format('YYYY-MM-DD'),

			loading: false,
			reports: [],
		}
	},
	methods: {
		async fetchData() {
			this.loading = true
			try {
				const res = await api.get('/summary/affiliate', {
					params: {
						start: this.startDate,
						end: this.endDate,
					},
				})
				this.reports = res
			} catch ({ message }) {
				this.$notify({ type: 'danger', message })
			} finally {
				this.loading = false
			}
		},
	},
	created() {
		this.fetchData()
	},
	watch: {
		startDate() {
			this.fetchData()
		},
		endDate() {
			this.fetchData()
		},
	},
}
</script>
